let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1RIcp")).then(() => parcelRequire('k3xlK'));